import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface ProdutoCandidato {
  ean: string;
  nome: string;
  imagem?: { url: string };
  negociacoes_ativas?: number;
  rating?: number;
  [key: string]: any;
}

/**
 * Seletor de produto usado na revisão de uma importação em lote
 * (`AdicionaNegociacaoCompostaComponent`) quando um item da lista tem mais de
 * um candidato no catálogo. Ao escolher, o pai popula `ean`/`nome`/`imagemUrl`
 * do `FormGroup` daquela linha — o mesmo padrão de dado que `addProduct()` já
 * usa hoje.
 */
@Component({
  selector: 'app-produto-candidato-selector',
  templateUrl: './produto-candidato-selector.component.html',
  styleUrls: ['./produto-candidato-selector.component.css']
})
export class ProdutoCandidatoSelectorComponent {
  @Input() candidatos: ProdutoCandidato[] = [];
  @Input() selectedEan?: string;
  @Output() selecionado = new EventEmitter<ProdutoCandidato>();

  get candidatoSelecionado(): ProdutoCandidato | null {
    return this.candidatos.find(candidato => candidato.ean === this.selectedEan) || null;
  }

  onChange(event: { value: ProdutoCandidato }): void {
    if (event?.value) {
      this.selecionado.emit(event.value);
    }
  }
}
